import React from "react";
import { useDriveList } from "../drive/hooks/use-drive-list";
import { DriveList } from "@/views/drive/driveList";
import { Pagination } from "@/views/drive/pagination";
import { ChevronDown, Download } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { DriveSearch } from "@/views/drive/driveSearch";
import { useSearchParams } from "react-router";
import { useDriveSearch } from "@/views/drive/hooks/use-drive-search";
import { DriveSkeleton } from "@/views/drive/driveSkeleton";

export const SharedView: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q");
  return (
    <div className="mx-auto p-8">
      <div className="mb-6 pb-4">
        <div className="mb-2 flex flex-col justify-between space-y-2 sm:flex-row sm:space-y-0">
          <h1 className="text-2xl font-bold">
            Shared with me
            <DropdownMenu modal={false}>
              <DropdownMenuTrigger asChild>
                <Button variant="empty" className="h-8 w-8 p-0">
                  <ChevronDown className="h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem className="cursor-pointer" asChild>
                  <a target="_blank" href={`/pf-document/export/shared`} className={"flex items-center"}>
                    <Download className="mr-2 h-4 w-4" />
                    Export
                  </a>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </h1>
        </div>
      </div>
      <DriveSearch />
      {query ? <SharedSearchList query={query} /> : <SharedList />}
    </div>
  );
};

interface SharedSearchListProps {
  query: string;
}

const SharedSearchList: React.FC<SharedSearchListProps> = ({ query }) => {
  const {
    isFetching: isLoading,
    displayItems,
    totalPages,
    setCurrentPage,
    itemsPerPage,
    currentPage,
  } = useDriveSearch({
    query,
    only_shared: true,
    entry_type: ["file"],
  });

  if (isLoading) {
    return <DriveSkeleton className="" hideSearch={true} hideHeader={true} />;
  }

  return (
    <>
      <DriveList
        sortItemsByDate={true}
        items={displayItems}
        parentFolder={null}
        isRootFolder={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
    </>
  );
};
const SharedList: React.FC = () => {
  const { isLoading, displayItems, totalPages, setCurrentPage, itemsPerPage, currentPage } = useDriveList({
    only_shared: true,
  });
  if (isLoading) {
    return <DriveSkeleton className="" hideSearch={true} hideHeader={true} />;
  }
  return (
    <>
      <DriveList
        sortItemsByDate={true}
        items={displayItems}
        parentFolder={null}
        isRootFolder={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
    </>
  );
};
